class Calculator
{
    constructor($scope){
        this.$scope = $scope;
        this.feet = 0;
        this.meters = 0;
        this.pounds = 0;
        this.kg = 0;
    }

    feetcalc()
    {
        this.meters = Math.round(this.feet * 0.3048 * 100) / 100;
    }

    metercalc()
    {
        this.feet = Math.round(this.meters*100/0.3048)/100;
    }

    poundcalc()
    {
        this.kg = Math.round(this.pounds*100*0.453592)/100;
    }

    kgcalc()
    {
        this.pounds = Math.round(this.kg*100/0.453592)/100;
    }


}

Calculator.$inject = ['$scope'];

export {Calculator}